import { style } from '@vanilla-extract/css';

export const modalTitleImageClass = style({
  width: 80,
  height: 80,
});
